import API from '@/shared/plugins/Api/API'
import { fetchAllPages } from './cursorPagination'

class ApplicationsV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  // Cursor-paginated server-side (100 per page); callers still get every
  // application in one array.
  async list (params = {}) {
    return fetchAllPages(this, { url: `${this.prefix}/application`, params })
  }

  async get (appName) {
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/application/${encodeURIComponent(appName)}`
    })
    return response
  }

  async create (body) {
    const response = await this.request({
      method: 'post',
      url: `${this.prefix}/application`,
      data: body
    })
    return response
  }

  async update (appName, body) {
    const response = await this.request({
      method: 'put',
      url: `${this.prefix}/application/${encodeURIComponent(appName)}`,
      data: body
    })
    return response
  }

  async delete (appName, { force } = {}) {
    await this.request({
      method: 'delete',
      url: `${this.prefix}/application/${encodeURIComponent(appName)}`,
      params: force ? { force: true } : {}
    })
  }
}

export default ApplicationsV3
